<template>
  <div class="integration-config">
    <div class="integration-config-card">
      <header>
        <div v-if="isProject" class="integration-icon">
          <LucideIcon icon="FileInput"/>
        </div>
        <div v-else-if="intTypeInfo.type === 'FIGMA'" class="integration-icon">
          <LucideIcon icon="RotateCw" style="left: -4px;position: relative;"/>
        </div>
        <div v-else class="integration-icon">
          <LucideIcon icon="RotateCw" style="left: -4px;position: relative;"/>
        </div>
        <div class="header-text">
          <h4 v-if="isProject">
            Project <span style="font-weight:600">{{ projectName }}</span>
            in metastory AI is connected to <span style="font-weight:600">{{ intProjectName }}</span> in {{ intTypeInfo.type }}
          </h4>
          <h4 v-else-if="intTypeInfo.type === 'FIGMA'">
            Workspace <span style="font-weight:600">{{ projectName }}.metastory.ai</span>
            is connected to <span style="font-weight:600">{{ intTypeInfo.domain }}</span>
          </h4>
          <h4 v-else>
            Workspace <span style="font-weight:600">{{ projectName }}.metastory.ai</span>
            is connected to <span style="font-weight:600">{{ intProjectName }}.{{ intTypeInfo.domain }}</span>
          </h4>
          <h5>Added by {{ user }} on {{ formattedDate }}</h5>
        </div>
        <ActionDropdownElement
          title="Actions"
          type="button"
          icon="EllipsisVertical"
          class="icon"
          :options="options"
          @change="actionFired"
        />
      </header>
    </div>
  </div>
</template>
<script lang="ts">
import {defineComponent, type PropType} from 'vue'
import {type DropdownNs, IntegrationNs} from '@shared/types'
import ActionDropdownElement from '@shared/components/elements/dropdown/action-dropdown.element.vue'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.extend(localizedFormat)

export default defineComponent({
  name: 'IntegrationConfigWidget',
  components: {
    ActionDropdownElement
  },
  props: {
    projectName: {
      type: String,
      default: ''
    },
    intProjectName: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      required: true
    },
    user: {
      type: String,
      required: true
    },
    isProject: {
      type: Boolean,
      default: true
    },
    intTypeInfo: {
      type: Object as PropType<IntegrationNs.IntegrationType>,
      required: true
    }
  },
  computed: {
    formattedDate (): string {
      return dayjs(this.date).format('LL')
    },
    options (): DropdownNs.DropdownOptionsItem[] {
      if (this.isProject) {
        return this.optionsProject
      }
      return this.optionsIntegration
    }
  },
  emits: ['onRemove', 'onConfigure'],
  data () {
    return {
      optionsIntegration: [
        {
          icon: 'Undo2',
          iconType: 'far',
          name: 'Reauthenticate',
          value: 'configure'
        },
        {
          icon: 'Trash2',
          iconType: 'far',
          name: 'Remove',
          value: 'remove'
        }
      ] as DropdownNs.DropdownOptionsItem[],
      optionsProject: [
        {
          icon: 'Trash2',
          iconType: 'far',
          name: 'Remove',
          value: 'remove'
        }
      ] as DropdownNs.DropdownOptionsItem[],
    }
  },
  methods: {
    actionFired (selectedItem: DropdownNs.DropdownOptionsItem) {
      if (selectedItem.value === 'remove') {
        this.$emit('onRemove')
      }
      if (selectedItem.value === 'configure') {
        this.$emit('onConfigure')
      }
    }

  }
})
</script>
<style lang="scss">


.integration-config {
  margin-bottom: var(--space-16);

  .integration-headline{
    margin-bottom: var(--space-16);
    font-size: var(--fs-14);
    color: var(--text-neutral);
  }

  &-card {
    background-color: var(--card-bg);
    border: 1px solid var(--card-border);
    box-shadow: var(--card-shadow);
    border-radius: $br-sm;
    padding: var(--space-16);
    margin-bottom: var(--space-16);

    &:hover{
      box-shadow: var(--shadow-lg);
    }

    .dropdown-project.dropdown .dropdown-item {
      font-size: var(--fs-14);
    }

    svg {
      font-size: var(--fs-12);
    }

    header {
      display: flex;

      .header-text {

        * {
          font-size: var(--fs-14);
        }

        h4 {
          color: var(--text-dark);
          font-weight: 400;
          margin-bottom: var(--space-6);
          line-height: 19px;
        }

        h5 {
          color: var(--text-neutral);
          margin-bottom: var(--space-0);
          font-size: var(--fs-12);
        }
      }

      .icon {
        margin-left: auto;
        margin-right: var(--space-0);
        display: flex;
        justify-content: center;
        align-items: flex-start;
      }
    }
  }

  .integration-icon{
    margin-right: var(--space-16);
    color: var(--text-neutral);
    width: 35px;
    margin-top: var(--space-6);
    svg{
      font-size: var(--fs-32);
    }
  }
}
</style>
